import { useEffect } from 'react';
import { PossibleZillowSession } from 'src/services/auth/session/ZillowSessionManager';
import { DatadogRUMService } from 'src/services/datadog/DatadogRUMService';
import { RefreshTokenError } from '../../../session/errors/RefreshTokenError';

export const useLogReportedRefreshError = (session: PossibleZillowSession) => {
    useEffect(() => {
        const logDatadog = async () => {
            if (session?.error?.type === 'RefreshTokenExpired') {
                return;
            }
            if (session?.error) {
                await DatadogRUMService.Client.getInstance().addError(new RefreshTokenError('Session refresh failed'), {
                    cause: session.error,
                });
            }
        };
        logDatadog();
    }, [session?.error]);
};
